import Vue from 'vue'
import _ from 'lodash';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import "babel-polyfill";


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '../../assets/css/main.css'
import Components from '@/common/components/index_rt.js'
import ModuleComponents from './components'
import Directive from '@/common/directive'
import '../index/style/index.scss';

window.$Env={};
PF.changeElementLocaleToEn=function(){
  locale.use(lang);
}
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Components)
Vue.use(ModuleComponents)
Vue.use(Directive)







// WEBPACK FOOTER //
// ./src/modules/contrib/main.js